<template>
  <vx-card class="mb-base" :title="$t('class-overview.assessment')" title-color="primary">
    <li class="flex flex-inline justify-between w-full">
      <div class="flex-1">
        <vs-chip class="cursor-pointer w-3/5" color="primary" transparent>
          {{ $t('class-overview.assessment-short') }}
        </vs-chip>
      </div>
      <div>
        <vs-chip class="cursor-pointer" color="primary" transparent>
          {{ $t('class-overview.score') }}
        </vs-chip>
        <vs-chip class="cursor-pointer" color="primary" transparent>
          {{ $t('class-overview.earn-score') }}
        </vs-chip>
      </div>
    </li>
    <li
      v-for="(assessment, index) in courseOutlineAssessments"
      :key="assessment.id + '_' + index" class="flex flex-inline justify-between items-center w-full px-3 pl-0"
    >
      <div class="flex-1 flex justify-start items-start">
        <vs-avatar :text="`${assessment.seq}`" class="bg-primary w-5 h-5 text-sm mr-2 p-2"/>
        <span class="text-sm mt-1">
          {{ assessment.assessment.nameLocal }}
        </span>
      </div>
      <div class="flex w-30 justify-between">
        <span class="w-16 text-right"> {{ assessment.score }} </span>
        <span class="w-16 text-right"> {{ getEarnedScore(assessment.assessment.id) }} </span>
      </div>
    </li>

    <!-- Total score footer -->
    <div v-if="studentScore" class="flex justify-end mt-2 mr-2 font-semibold">
      <span class="text-sm text-primary mr-2">{{ $t('class-overview.score') }}:</span>
      <span class="text-sm w-16 text-right">{{ studentScore.fullScore }}</span>
      <span class="text-sm w-16 text-right">{{ studentScore.totalScore }}</span>
    </div>

    <!-- Remark footer -->
    <div v-if="studentScore && studentScore.remark" class="mt-2 mr-2">
      <span class="text-sm font-semibold text-primary mr-2">{{ $t('class-overview.remark') }}:</span>
      <span class="text-sm">{{ studentScore.remark }}</span>
    </div>
  </vx-card>
</template>

<script>
import store from '@/store';
import StudentScore from '@/store/modules/student-score';
import { createNamespacedHelpers } from 'vuex';

if (!store.state.StudentScore) store.registerModule('StudentScore', StudentScore);

const {
  mapActions: mapStudentScoreActions,
} = createNamespacedHelpers('StudentScore');

export default {
  name: "AssessmentInfo",
  props: ['courseOutlineAssessments', 'studentEnrollDetailId'],
  data() {
    return {
      studentScore: null,
    };
  },
  methods: {
    ...mapStudentScoreActions({
      getStudentScoresByFilter: 'getStudentScoresByFilter',
    }),
    getEarnedScore(assessmentId) {
      if (!this.studentScore || !this.studentScore.studentScoreDetails) return '-';
      const detail = this.studentScore.studentScoreDetails.find(
        d => d.assessment && d.assessment.id === assessmentId
      );
      return detail ? detail.score : '-';
    },
    async loadStudentScore() {
      if (!this.studentEnrollDetailId) return;
      const results = await this.getStudentScoresByFilter({
        studentScoreFilterInput: { studentEnrolDetailId: this.studentEnrollDetailId },
      });
      this.studentScore = results && results.length > 0 ? results[0] : null;
    },
  },
  async mounted() {
    await this.loadStudentScore();
  },
}
</script>

<style scoped>

</style>
